<div class="flex flex-row justify-between items-center">
  <div class="flex items-center ml-4">
    <mat-form-field appearance="outline" class="w-48">
      <mat-label>{{ 'PAGE_PATIENT_LIST.sort' | translate }}</mat-label>
      <mat-select
        (selectionChange)="onSortingTypeChange($event)"
        [value]="currentSortingType"
        class="filter-item"
      >
        <mat-option [value]="sortingTypes.ByDocumentType" class="option-list">
          {{ 'GENERAL.sort_document_type' | translate }}
        </mat-option>
        <mat-option [value]="sortingTypes.ByDate" class="option-list">
          {{ 'GENERAL.sort_date' | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <mat-chip-listbox class="flex flex-row gap-1">
    <ng-container *ngFor="let region of regions">
      <mat-chip-option
        (click)="selectRegion(region)"
        [selectable]="
          !region.selected && (!region.code?.startsWith('fixed_') || hasRecordsForRegion(region))
        "
        [selected]="region.selected"
        [disabled]="region.code?.startsWith('fixed_') && !hasRecordsForRegion(region)"
        [class.has-documents]="!region.code?.startsWith('fixed_')"
        class="shadow"
      >
        <span class="font-light truncate">
          {{ region.long_text ?? region.short_text }}
        </span>
      </mat-chip-option>
    </ng-container>
  </mat-chip-listbox>

  <div class="flex flex-row self-start items-center">
    <button (click)="onClickOpenTextEditor()" mat-icon-button matTooltip="Dokument erstellen">
      <mat-icon>note_add</mat-icon>
    </button>
    <button
      (click)="onClickOpenDoctorFormular()"
      mat-icon-button
      matTooltip="Arztbericht erstellen"
    >
      <mat-icon svgIcon="prescriptions"></mat-icon>
    </button>
    <button
      (click)="onClickOpenNurseFormular()"
      mat-icon-button
      matTooltip="Pflegebericht erstellen"
    >
      <mat-icon svgIcon="clinical_notes"></mat-icon>
    </button>
  </div>
</div>
